import {NgModule} from '@angular/core';
import {PreloadAllModules, RouterModule, Routes} from '@angular/router';

const routes: Routes = [
    {
        path: '',
        loadChildren: () => import('./tabs/tabs.module').then(m => m.TabsPageModule)
    },
    {
        path: 'login',
        loadChildren: () => import('./login/login.module').then(m => m.LoginPageModule)
    },
    {
        path: 'pilot',
        loadChildren: () => import('./pilot-input-table/pilot-input-table.module').then(m => m.PilotInputTablePageModule)
    },
    {
        path: 'profil',
        loadChildren: () => import('./profil/profil.module').then(m => m.ProfilPageModule)
    },
    {
        path: 'cycle-target',
        loadChildren: () => import('./cycle-target/cycle-target.module').then(m => m.CycleTargetPageModule)
    },
    {
        path: 'meta',
        loadChildren: () => import('./meta-daten/meta-daten.module').then(m => m.MetaDatenPageModule)
    },
    {
        path: 'pay-wall',
        loadChildren: () => import('./pay-wall/pay-wall.module').then(m => m.PayWallPageModule)
    },
    {
        path: 'register',
        loadChildren: () => import('./register/register.module').then(m => m.RegisterPageModule)
    },
    {
        path: 'forgotton-password',
        loadChildren: () => import('./forgotton-password/forgotton-password.module').then(m => m.ForgottonPasswordPageModule)
    }

];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, {preloadingStrategy: PreloadAllModules})
    ],
    exports: [RouterModule]
})
export class AppRoutingModule {
}
